
import { LatLng } from "@/types";
import { computed, defineComponent, ref, watch } from "vue";

export default defineComponent({
  name: "CoordinatesInput",
  props: {
    value: {
      type: Object as () => LatLng | null,
      default: () => ({ lat: 0, lng: 0 }),
    },
  },
  emits: ["input"],
  setup(props, { emit }) {
    const isValidCoords = ref<boolean>(false);
    const coordsString = computed({
      get(): string {
        return toString(props.value);
      },
      set(val: string) {
        if (isValidCoords.value) {
          emit("input", toLatLng(val));
        }
      },
    });
    watch(coordsString, (x) => (isValidCoords.value = validate(x)), {
      immediate: true,
    });

    function updateValue(coordsString: string) {
      isValidCoords.value = validate(coordsString);
      if (isValidCoords.value) {
        emit("input", toLatLng(coordsString));
      }
    }

    function toLatLng(coordsString: string): LatLng {
      const coords = coordsString.split(",").map((x) => parseFloat(x));
      return {
        lat: coords[0],
        lng: coords[1],
      };
    }

    function toString(latlng: LatLng | null): string {
      if (!latlng || (!latlng.lat && !latlng.lng)) {
        return "";
      }
      return `${latlng.lat || 0}, ${latlng.lng || 0}`;
    }

    function validate(coordsString: string): boolean {
      const coords = coordsString.split(",").map((x) => parseFloat(x));
      if (coords.length !== 2) {
        return false;
      }

      const isLatValid = !!coords[0] && coords[0] >= -90 && coords[0] <= 90;
      const isLngValid = !!coords[1] && coords[1] >= -180 && coords[1] <= 180;
      return isLatValid && isLngValid;
    }
    return {
      isValidCoords,
      coordsString,
      updateValue,
    };
  },
});
